module.exports = __webpack_public_path__ + "static/media/boothBg.d362ef9b.jpg";